import { Box, Typography, Divider, Accordion, AccordionSummary, AccordionDetails, IconButton } from '@mui/material';
import { Add, Close } from '@mui/icons-material';
import React, { useState } from 'react';
import Images from '../../../utils/Images';

// You can also import your logo, e.g. import Logo from '../../assets/logo.png';
const logoUrl = Images.xpanseLogo; // <-- Replace with your logo

const faqs = [
  {
    question: "What is included in my subscription?",
    answer: "Each subscription plan includes different products. Based on the plan you purchase, a corresponding menu will be displayed.",
  },
  {
    question: "Where can I purchase a subscription?",
    answer: "You can purchase your coffee subscription through the Xpanse App. Please note: you must register for an Xpanse App account to use your subscription.",
  },
  // {
  //   question: "Can I use my coffee subscription for dine-in?",
  //   answer: "Yes, your subscription can be used for both dine-in and takeaway orders.",
  // },
  {
    question: "Will my coffee subscription be automatically renewed?",
    answer: "No, it will not renew automatically. You will receive reminders via email, WhatsApp, and app notifications when your subscription is about to expire.",
  },
  {
    question: "Can I purchase a coffee subscription for multiple months?",
    answer: "No, all our subscription plans are valid for a month by default with conditions applied.",
  },
  {
    question: "Can I pay for a subscription using GPay?",
    answer: "Yes, we accept all major payment methods including UPI, GPay, debit cards, credit cards, and net banking.",
  },
  {
    question: "Can I use my subscription for dine-in & takeaway?",
    answer: "Yes! Your subscription works for dine-in & takeaway. It's flexible.",
  },
  {
    question: "Can I cancel my subscription mid-month?",
    answer: "No, we currently do not offer cancellations or refunds once the subscription is purchased.",
  },
  {
    question: "What in case of temporary outlet closure?",
    answer: "In the event that a Xpanse Café outlet becomes fully non-operational for an entire calendar day due to unforeseen technical faults, utility outages, equipment failure, safety incidents, maintenance work, natural calamities, government-imposed restrictions, or any force majeure circumstances beyond the control of Xpanse Café, the validity of the active Subscription Plan of an affected Subscriber may be extended by one (1) additional day, subject to the following conditions. The Subscriber attempted to redeem their daily entitlement on the affected day but was unable to do so due to the complete closure of the store for that full day. The closure was unannounced and not part of scheduled maintenance, holiday hours, or any prior notice communicated through official Xpanse channels and The Subscriber registers a valid claim through the in-app help section or customer support within 1 hours of the missed redemption attempt."
  }
  // {
  //   question: "",
  //   answer: "",
  // },
  // {
  //   question: "",
  //   answer: "",
  // },
  // {
  //   question: "",
  //   answer: "",
  // },
];

const SubscriptionFAQ = () => {
  const [expanded, setExpanded] = useState(0);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        mx: 'auto',
        my: 3,
        bgcolor: '#f8fbff',
        borderRadius: 3,
        p: { xs: 2, sm: 4 },
        boxShadow: '0 4px 24px 0 rgba(42,100,150,0.10)',
        maxWidth: 420,
      }}
    >
      {/* Logo at the top */}
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
        <img src={logoUrl} alt="Subscription FAQ" style={{ width: 100, height: 100 }} />
      </Box>

      {/* Main Heading */}
      <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center" color="#0E4961">
        Frequently Asked Questions
      </Typography>
      {/* Subtitle */}
      <Typography
        sx={{
          color: '#0E4961',
          textAlign: 'center',
          mb: 2,
          fontWeight: 500,
          fontSize: 16,
        }}
      >
        All you need to know about your subscription
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {faqs.map((faq, idx) => (
        <Accordion
          key={idx}
          expanded={expanded === idx}
          onChange={handleChange(idx)}
          sx={{
            boxShadow: 'none',
            borderBottom: idx !== faqs.length - 1 ? '1px solid #e0e0e0' : 'none',
            '&:before': { display: 'none' },
            mb: 0,
            px: 2,
            background: 'transparent',
            transition: 'background 0.2s',
            borderRadius: '12px',
            '&.Mui-expanded': {
              background: '#eaf6ff'
            }
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === idx
                ? <IconButton disableRipple size="small"><Close color="primary" /></IconButton>
                : <IconButton disableRipple size="small"><Add color="primary" /></IconButton>
            }
            aria-controls={`faq-content-${idx}`}
            id={`faq-header-${idx}`}
            sx={{
              px: 0,
              minHeight: '56px',
              '& .MuiAccordionSummary-content': {
                margin: 0,
                alignItems: 'center',
                color: '#0E4961'
              },
            }}
          >
            <Typography fontWeight="bold" sx={{ fontSize: 17 }}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0, pb: 2 }}>
            <Typography sx={{ color: '#0097E6', fontSize: 15 }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default SubscriptionFAQ;
